const getDaysFromDate = (date: string) => {
  let date_1: Date = new Date(date);
  let date_2: Date = new Date();
  let difference = date_1.getTime() - date_2.getTime();
  let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
  return Math.abs(TotalDays);
};

export default getDaysFromDate;
